var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { BaseService } from '../../base';
import { apiSettings } from '../api';
export var TokenTypes;
(function (TokenTypes) {
    TokenTypes["Umbraco"] = "umbraco";
    TokenTypes["BookingGuest"] = "booking_guest";
    TokenTypes["BookingManageGuest"] = "booking_manage_guest";
    TokenTypes["BookingManage"] = "booking_manage";
    TokenTypes["Match"] = "match";
    TokenTypes["Patient"] = "patient";
    TokenTypes["Checkin"] = "checkin";
})(TokenTypes || (TokenTypes = {}));
var AuthService = /** @class */ (function (_super) {
    __extends(AuthService, _super);
    function AuthService() {
        var _this = _super.call(this, 'auth') || this;
        _this.TryGetTokenFromSessionStorage();
        return _this;
    }
    Object.defineProperty(AuthService.prototype, "BaseUrl", {
        get: function () {
            return apiSettings.ServiceUrl;
        },
        enumerable: false,
        configurable: true
    });
    AuthService.prototype.TryGetTokenFromSessionStorage = function (token_type) {
        if (!token_type) {
            return (this.TryGetTokenFromSessionStorage(TokenTypes.Patient) ||
                this.TryGetTokenFromSessionStorage(TokenTypes.Match) ||
                this.TryGetTokenFromSessionStorage(TokenTypes.BookingGuest));
        }
        var jwt = window.sessionStorage.getItem("".concat(token_type, "_jwt"));
        if (jwt) {
            this.Token = {
                jwt: jwt,
                token_type: token_type,
            };
            return true;
        }
        return false;
    };
    Object.defineProperty(AuthService.prototype, "Authorization", {
        get: function () {
            return this.token ? "Bearer ".concat(this.token.jwt) : undefined;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AuthService.prototype, "Token", {
        get: function () {
            return this.token;
        },
        set: function (_a) {
            var jwt = _a.jwt, token_type = _a.token_type;
            this.token = { jwt: jwt, token_type: token_type };
            sessionStorage.setItem("".concat(token_type, "_jwt"), jwt);
        },
        enumerable: false,
        configurable: true
    });
    AuthService.prototype.AssertToken = function (token_type) {
        return this.Token.token_type !== token_type || this.TryGetTokenFromSessionStorage(token_type);
    };
    AuthService.prototype.ConnectBookingApp = function (siteId, isNewPatient) {
        return __awaiter(this, void 0, void 0, function () {
            var data, formData, _i, _a, _b, key, value, _c, value_1, item, response;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        if (!this.AssertToken(TokenTypes.Umbraco)) {
                            throw 'Unauthorized';
                        }
                        data = {
                            grant_type: 'temporary_token',
                            client_id: this.client_id,
                            audiences: ['myhealth-bperp-api', 'myhealth-auth-api'],
                            bp_site_id: siteId,
                            user_claim_type: 'MyhealthBPPatient',
                            is_new_patient: isNewPatient,
                        };
                        formData = new URLSearchParams();
                        for (_i = 0, _a = Object.entries(data); _i < _a.length; _i++) {
                            _b = _a[_i], key = _b[0], value = _b[1];
                            if (Array.isArray(value)) {
                                for (_c = 0, value_1 = value; _c < value_1.length; _c++) {
                                    item = value_1[_c];
                                    formData.append(key, item);
                                }
                            }
                            else {
                                formData.append(key, value.toString());
                            }
                        }
                        return [4 /*yield*/, this.post('connect/token', formData)];
                    case 1:
                        response = _d.sent();
                        this.Token = { jwt: response.access_token, token_type: TokenTypes.BookingGuest };
                        return [2 /*return*/, response];
                }
            });
        });
    };
    AuthService.prototype.ConnectManageBookingAppLite = function (appt_hash) {
        return __awaiter(this, void 0, void 0, function () {
            var data, formData, _i, _a, _b, key, value, _c, value_2, item, response;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        data = {
                            grant_type: 'temporary_token',
                            client_id: 'myhealth_manage_booking_lite',
                            audiences: ['myhealth-auth-api'],
                            appt_hash: appt_hash,
                        };
                        formData = new URLSearchParams();
                        for (_i = 0, _a = Object.entries(data); _i < _a.length; _i++) {
                            _b = _a[_i], key = _b[0], value = _b[1];
                            if (Array.isArray(value)) {
                                for (_c = 0, value_2 = value; _c < value_2.length; _c++) {
                                    item = value_2[_c];
                                    formData.append(key, item);
                                }
                            }
                            else {
                                formData.append(key, value.toString());
                            }
                        }
                        return [4 /*yield*/, this.post('connect/token', formData)];
                    case 1:
                        response = _d.sent();
                        this.Token = { jwt: response.access_token, token_type: TokenTypes.BookingManageGuest };
                        return [2 /*return*/, response];
                }
            });
        });
    };
    AuthService.prototype.BookingTempToken = function (hash) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.post('manage-booking/access', hash)];
                    case 1:
                        response = _a.sent();
                        this.Token = { jwt: response.access_token, token_type: TokenTypes.BookingManage };
                        return [2 /*return*/, response];
                }
            });
        });
    };
    AuthService.prototype.ConnectBookingGuest = function (patientCheck) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.AssertToken(TokenTypes.BookingGuest)) {
                            throw 'Unauthorized';
                        }
                        return [4 /*yield*/, this.post("booking/initial", patientCheck)];
                    case 1:
                        response = _a.sent();
                        this.Token = { jwt: response.tokenResponse.access_token, token_type: TokenTypes.Match };
                        return [2 /*return*/, response];
                }
            });
        });
    };
    AuthService.prototype.ConnectPieLite = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.TryGetTokenFromSessionStorage(TokenTypes.Checkin);
                        return [4 /*yield*/, this.post("pie-lite/initial", null)];
                    case 1:
                        response = _a.sent();
                        if (response) {
                            this.Token = { jwt: response.tokenResponse.access_token, token_type: TokenTypes.Match };
                            return [2 /*return*/, response];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    AuthService.prototype.VerifyCode = function (verification_code, verification_contact_type) {
        return __awaiter(this, void 0, void 0, function () {
            var authRequest, urlEncoded, _i, _a, _b, k, v, _c, v_1, w, response;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        authRequest = {
                            verification_code: verification_code,
                            verification_contact_type: verification_contact_type,
                            grant_type: 'otp',
                            client_secret: this.auth_client_secret,
                            client_id: this.client_id,
                            audiences: ['myhealth-bperp-api', 'myhealth-auth-api', 'myhealth-comms-api'],
                        };
                        urlEncoded = new URLSearchParams();
                        for (_i = 0, _a = Object.entries(authRequest); _i < _a.length; _i++) {
                            _b = _a[_i], k = _b[0], v = _b[1];
                            if (v === undefined || v === null) {
                                continue;
                            }
                            if (Array.isArray(v)) {
                                for (_c = 0, v_1 = v; _c < v_1.length; _c++) {
                                    w = v_1[_c];
                                    urlEncoded.append(k, w);
                                }
                            }
                            else {
                                urlEncoded.append(k, "".concat(v));
                            }
                        }
                        return [4 /*yield*/, this.post('connect/token', urlEncoded)];
                    case 1:
                        response = _d.sent();
                        this.Token = { jwt: response.access_token, token_type: TokenTypes.Patient };
                        sessionStorage.setItem('jwt', response.access_token);
                        return [2 /*return*/, response];
                }
            });
        });
    };
    return AuthService;
}(BaseService));
export { AuthService };
export * from './types';
